export default __webpack_public_path__ + "static/media/login_background.f4afe6f7.jpg";